module.exports = __webpack_public_path__ + "static/img/card_btn_home.92504084.png";